import React from "react";
import FlightSegmentTimeline from "./FlightSegmentTimeline";
import "./FlightLegDetails.css";

function ConnectionBlock({ connection }) {
  if (!connection) return null;
  return (
    <div className="fe2-leg__connection">
      <strong className="fe2-leg__connection-title">
        חיבור · <span className="fe2-ltr">{connection.airport}</span>
        {connection.airportName ? ` · ${connection.airportName}` : ""}
      </strong>
      <div className="fe2-leg__connection-meta">
        <span>
          משך: <span className="fe2-ltr">{connection.duration}</span>
        </span>
        {connection.terminal ? <span>טרמינל: {connection.terminal}</span> : null}
      </div>
      {connection.selfTransfer ? (
        <p className="fe2-leg__warn">Self-transfer — יש לאסוף כבודה ולהירשם מחדש</p>
      ) : null}
      {connection.airportChange ? (
        <p className="fe2-leg__warn">שינוי טרמינל / שדה תעופה — יש להקצות זמן מעבר</p>
      ) : null}
    </div>
  );
}

function SegmentRow({ segment }) {
  if (segment.type === "connection") {
    return <ConnectionBlock connection={segment} />;
  }
  return (
    <div className="fe2-leg__seg">
      <div className="fe2-leg__seg-times">
        <span className="fe2-ltr">
          {segment.depTime} {segment.depIata}
        </span>
        <span aria-hidden>→</span>
        <span className="fe2-ltr">
          {segment.arrTime} {segment.arrIata}
        </span>
      </div>
      <div className="fe2-leg__seg-meta">
        <span className="fe2-ltr">{segment.flightNumber}</span>
        {segment.duration ? <span className="fe2-ltr">{segment.duration}</span> : null}
        {segment.operatedBy ? <span>{segment.operatedBy}</span> : null}
      </div>
    </div>
  );
}

export default function FlightLegDetails({ leg, embedded = false }) {
  if (!leg) return null;
  const hasSegments = Array.isArray(leg.segments) && leg.segments.length > 0;
  const facts = [
    leg.flightNumber ? { label: "טיסה", value: leg.flightNumber, ltr: true } : null,
    leg.operatedBy ? { label: "מפעיל", value: leg.operatedBy } : null,
    leg.cabin ? { label: "מחלקה", value: leg.cabin } : null,
    leg.aircraft ? { label: "מטוס", value: leg.aircraft } : null,
  ].filter(Boolean);

  return (
    <section className={embedded ? "fe2-leg fe2-leg--embedded" : "fe2-leg"}>
      <header className="fe2-leg__head">
        <h2 className="fe2-leg__title">{leg.title || "טיסה"}</h2>
        {leg.weekdayLabel ? (
          <span className="fe2-leg__date">{leg.weekdayLabel}</span>
        ) : null}
      </header>

      <FlightSegmentTimeline leg={leg} />

      {hasSegments ? (
        <div className="fe2-leg__segments">
          {leg.segments.map((seg, idx) => (
            <SegmentRow
              key={`${seg.flightNumber || seg.airport || "c"}-${idx}`}
              segment={seg}
            />
          ))}
        </div>
      ) : null}

      {facts.length ? (
        <div className="fe2-leg__ops">
          {facts.map((f) => (
            <span key={f.label} className="fe2-leg__ops-item">
              <span className="fe2-leg__ops-label">{f.label}</span>
              <strong className={f.ltr ? "fe2-ltr" : undefined}>{f.value}</strong>
            </span>
          ))}
        </div>
      ) : null}
    </section>
  );
}
